import { useNavigate } from 'react-router-dom';
import type { MenuItem } from '@/mocks/profile';

interface Props {
  items: MenuItem[];
}

const menuIconBg: Record<string, string> = {
  'text-red-500': 'bg-red-50 text-red-500',
  'text-purple-500': 'bg-purple-50 text-purple-500',
  'text-blue-500': 'bg-blue-50 text-blue-500',
  'text-green-500': 'bg-green-50 text-green-500',
};

export default function ProfileMenu({ items }: Props) {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-2xl mt-2 overflow-hidden shadow-sm border border-background-200/50">
      {items.map((item, index) => {
        const bgClass = menuIconBg[item.iconColor] || 'bg-foreground-50 text-foreground-500';
        return (
          <button
            key={item.id}
            onClick={() => item.path && navigate(item.path)}
            className={`w-full flex items-center justify-between px-4 py-3.5 cursor-pointer hover:bg-background-50/80 transition-colors active:scale-[0.99] ${
              index < items.length - 1 ? 'border-b border-background-100/80' : ''
            }`}
          >
            <div className="flex items-center gap-3">
              <div className={`w-9 h-9 rounded-xl flex items-center justify-center ${bgClass}`}>
                <i className={`${item.icon} text-lg`} />
              </div>
              <span className="text-foreground-800 text-sm font-medium">{item.label}</span>
            </div>
            <div className="flex items-center gap-2">
              {item.badge && item.badge > 0 && (
                <span className="min-w-[18px] h-[18px] px-1 bg-primary-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center">
                  {item.badge}
                </span>
              )}
              <i className="ri-arrow-right-s-line text-foreground-300 text-lg" />
            </div>
          </button>
        );
      })}
    </div>
  );
}